import { MainLoader, ResourceLoader, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { SubsidiaryContactInfos } from '../../../../interfaces/SubsidiaryContactInfos';
import { SubsidiariesResourceInfo } from '../SubsidiariesResource';
import SubsidiaryLink from './SubsidiaryLink/SubsidiaryLink';

export interface SubsidiaryLinksProps { }

const SubsidiaryLinks: FC<SubsidiaryLinksProps> = () => {
  const subsidiaries: SubsidiaryContactInfos[] = useScopedSelector('/App.features.personalInformation.subsidiaries');
  return (
    <ResourceLoader
      inlineErrorMessage={false}
      buttonAlign="left"
      resourceSrc={SubsidiariesResourceInfo.name}
      CustomLoader={MainLoader}
    >
      {subsidiaries?.map((x, i) => <SubsidiaryLink key={i} subsidiary={x} />)}
    </ResourceLoader>
  );
};

export default SubsidiaryLinks;
